import { getSpacing, getFontSize, getColorAlias } from '../../../../utils/index.js';
import styled, { css } from 'styled-components';

const sharedImagePrefixStyling = css `
  height: ${getSpacing('s07')};
  width: ${getSpacing('s07')};
  border-radius: ${(props) => props.type === 'avatar'
    ? props.theme.radius.roundedE
    : props.theme.radius.roundedB};
`;
const ListItemPrefixWrapper = styled.div `
  display: flex;
  height: 100%;
  padding-inline: ${getSpacing('s02')};
  align-items: ${(props) => props.type === 'action' || props.type === 'icon' ? 'baseline' : 'center'};
  justify-content: center;

  div {
    margin: 0;
  }

  & > svg,
  & > div > svg {
    ${(props) => props.type === 'illustration'
    ? getFontSize('size24')
    : getFontSize('size14')};
    fill: ${getColorAlias('interactivePrimary')};
  }

  img {
    object-fit: cover;
    ${sharedImagePrefixStyling}
  }
`;
const ImagePlaceholder = styled.div `
  ${sharedImagePrefixStyling}
  background-color: ${getColorAlias('contentSubdued')};
`;

export { ImagePlaceholder, ListItemPrefixWrapper };
